import { Service } from '@roc/feature-app-core';

const url = {
  GET_PROPERTY_APPRAISAL_CONFIRM_VALUATION_STATUS: '/api/v1/roc-valuation/taskValuation/getConfirmValuationStatus',
  SAVE_CONFIRM_VALUATION_STATUS: '/api/v1/loan/saveConfirmValuationStatus',
  PROCESS_APPRAISAL_REFUND: '/api/v1/loan/processAppraisalRefund',
};

export class FirstAppraisalValueConfirmationService extends Service {

  getPropertyAppraisalConfirmValuationStatus = (loanId, propertyId) => {
    return this.get(url.GET_PROPERTY_APPRAISAL_CONFIRM_VALUATION_STATUS, { loanId, propertyId });
  };

  saveConfirmValuationStatus = (taskId, status) => {
    return this.put(`${url.SAVE_CONFIRM_VALUATION_STATUS}?taskId=${taskId}&status=${status}`, {});
  };

  processAppraisalRefund = (loanId, propertyId, appraisalType) => {
    return this.post(url.PROCESS_APPRAISAL_REFUND, { loanId, propertyId, appraisalType });
  };
}